import React, { FC, memo } from 'react';
import get from 'lodash/get';
import sortBy from 'lodash/sortBy';
import last from 'lodash/last';

// import { useConfig } from '@server/lib/config';

import SEOComponent from './components/seo';
import Description from './components/product-description';
import Content from './components/product-content';

import ProductCategory from './sub-modules/product-category/lazy';
import Comments from './sub-modules/comment/dynamic';
import RecentlyView from '@views/modules/recent-view/lazy';
import CategoryList from './sub-modules/category-list/lazy';
const ROOT_CATEGORY = 2;

type Props = {
  data: any;
};

export const Product: FC<Props> = ({ data }) => {
  // const { IS_BETA = false } = useConfig();

  const description =
    get(data, 'product.description') ||
    get(data, 'product.attributes.description');
  const shopeeId = get(data, 'product.shopeeId');
  const categories = get(data, 'product.categories');
  const selectedCategory = last(
    sortBy(categories, [(f) => get(f, 'path', '').length])
  );
  const categoryId = parseInt(get(selectedCategory, 'id', 1));
  const canViewRating = get(data, 'product.attributes.canViewRating', false);

  return (
    <>
      {data && <SEOComponent data={data} />}
      <Content data={data} />
      {/* <Description data={description} /> */}
      {!!shopeeId && canViewRating && <Comments shopeeId={shopeeId} />}
      {categoryId && categoryId !== ROOT_CATEGORY && (
        <>
          <CategoryList categoryId={categoryId} />
          <ProductCategory categoryId={categoryId} />
        </>
      )}
      <RecentlyView />
    </>
  );
};

export default memo(Product);
